<script lang="ts">
    import { apiBaseURL } from "../../../config"
    import { navigate } from "svelte-routing"
    import { fly } from "svelte/transition"
    let container
    let videoElement
    let videoText
    let videoWrapper
    let cooldown = false
    export let col
    export let siteId
</script>

<div id="wrapper" class="video-container" bind:this="{container}">
    <div class="video-wrapper video-wrapper-big" bind:this="{videoWrapper}">
        <div class="text shown" bind:this="{videoText}">
            <h2 in:fly="{{ duration: 1000, delay: 500, y: 50, opacity: 0 }}">{col.titleVideo}</h2>
            <p in:fly="{{ duration: 1000, delay: 500, y: 50, opacity: 0 }}">
                {col.descriptionVideo}
            </p>
        </div>
        <video
            autoplay
            class="video"
            playsinline
            src="{`${apiBaseURL}content/${siteId}/${col.video?.src}`}"
            loop
            alt="video1"
            muted
            bind:this="{videoElement}"><track kind="captions" /></video
        >
    </div>
</div>

<style lang="less">
    @import "../../assets/css/variables.less";

    #wrapper {
        width: 100%;
        flex: 2;
    }

    .video-wrapper {
        width: 100%;
        display: flex;
        max-height: min(700px, 55vh);
        overflow: hidden;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 10;
        }
        @media @mobile {
            .hidden {
                p,
                button {
                    visibility: hidden !important;
                    opacity: 0;
                    height: 0px;
                    margin-top: 0px !important;
                    transition: opacity 0s;
                }
                h2 {
                    margin-bottom: 0px !important;
                    transform: translateY(50%);
                }
            }

            .shown {
                opacity: 1;
                visibility: visible;
            }
        }

        @media @desktop {
            .hidden {
                h2 {
                    visibility: hidden;
                    transition: opacity 0s;
                }
            }
        }

        .text {
            position: absolute;
            z-index: 20;
            max-width: 85%;
            color: rgb(255, 255, 255);
            animation-delay: 500ms;
            bottom: 35px;
            left: 35px;

            @media @mobile {
                h2 {
                    font-size: 2.8rem;
                    font-weight: bold;
                    line-height: normal;
                    margin-bottom: 5px;
                }
                p {
                    line-height: normal;
                }

                button {
                    border-top: 3px solid white;
                    font-size: 1.4rem;
                    font-weight: bold;
                    color: white;
                    margin-top: 15px;
                }
            }
            @media @desktop {
                max-width: 70%;
                h2 {
                    font-size: 2.7rem;
                }
                p {
                }

                button {
                    font-size: 1.5rem;
                }
            }
        }
    }

    .video {
        width: 100%;
        min-height: max(35vh, 400px);
        height: 100% !important;
        object-fit: cover;
    }

    @media (max-width: 1023px) {
        .video-container {
            flex-direction: column;
        }

        .text {
            max-width: 90%;
        }

        video {
            height: 100% !important;
            min-height: max(45vh, 60vw) !important;
            width: auto !important;
            min-width: 100%;
            object-fit: cover;
            object-position: center;
        }

        .video-wrapper-small,
        .video-wrapper-big {
            width: 100%;
        }
    }
</style>
